import { useState } from 'react';
import { useDispatch } from 'react-redux';

const useLoading = (
  defaultLoading = false,
  defaultPrincipal = 'Procesando...',
  defaultSecudanrio = '',
) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(defaultLoading);
  const [principal, setPrincipal] = useState(defaultPrincipal);
  const [secundario, setSecundario] = useState(defaultSecudanrio);

  const resetLoading = (isLoading = false) => {
    setLoading(isLoading);
    setPrincipal(defaultPrincipal);
    setSecundario(defaultSecudanrio);
  };

  return {
    values: {
      loading,
      principal,
      secundario,
    },
    setLoading,
    setPrincipal,
    setSecundario,
    resetLoading,
  };
};

export default useLoading;
